/* ===========================================================================
   ABOUT US — page logic.

   SOURCE OF TRUTH: design-system/ui_kits/website/about.html, the second
   <script> block (the vanilla port of the handoff's DCLogic class). Behaviour
   is unchanged; the only edits are the ones Shopify forces:

   - a run-once guard, because all six About sections emit this same <script src>
   - every listener/observer bind is claimed against its element once, so
     re-running init() on shopify:section:load wires only what is new
   - the scroll loop, the two tickers and the resize hooks are page singletons
   - the tickers resolve #heroWord / the deck LIVE instead of closing over them,
     so a section added or removed in the editor is picked up

   Everything queries by ID/class at document level, so it does not care that
   the six sections are now separate DOM subtrees.
   =========================================================================== */

/* About Us — vanilla port of the handoff's DCLogic class.
   Same behaviour, no framework. Mobile additions are marked MOBILE. */
(function () {
  /* Six About sections each emit this same <script src>, and Shopify re-emits it
     when a section is re-rendered in the theme editor. Duplicate tags DO execute
     (unlike duplicate stylesheets), so the module body must run exactly once. */
  if (window.__twsAboutLogic) return;
  window.__twsAboutLogic = true;

  var WORDS = ['poets', 'debut novelists', 'essayists', 'memoirists', 'rule-breakers'];

  var S = { w: 0, ch: 0, mn: 0, sc: 0, v: 0 };
  var $  = function (q, r) { return (r || document).querySelector(q); };
  var $$ = function (q, r) { return Array.prototype.slice.call((r || document).querySelectorAll(q)); };
  var reduce = matchMedia('(prefers-reduced-motion:reduce)').matches;

  /* The rotating words are authored in the markup on Shopify (one block each,
     serialised into data-words) and hardcoded here in the local file. Reading
     the attribute with WORDS as the fallback keeps ONE implementation for both. */
  function heroWords(el) {
    var a = el && el.getAttribute('data-words');
    a = a ? a.split('|') : null;
    return (a && a.length && a[0]) ? a : WORDS;
  }


  /* init() re-runs on shopify:section:load, so every listener/observer bind is
     claimed against its element exactly once. Returns true the first time only. */
  function claim(el, key) {
    if (!el) return false;
    var k = 'twsab' + key;
    if (el.getAttribute('data-' + k)) return false;
    el.setAttribute('data-' + k, '1');
    return true;
  }
  /* singletons: things that must exist once per PAGE, not once per element */
  var loopOn = false, timersOn = false, deckDragOn = false, sizeHooksOn = false;
  var vHold = false, wHold = false;

  /* ── headline type: every word rises out of its own mask ── */
  function splitWords() {
    var wrap = function (el) {
      $$('*', el); // no-op guard for empty nodes
      Array.prototype.slice.call(el.childNodes).forEach(function (n) {
        if (n.nodeType === 3) {
          if (!n.textContent.trim()) return;
          var frag = document.createDocumentFragment();
          n.textContent.split(/(\s+)/).forEach(function (p) {
            if (!p) return;
            if (/^\s+$/.test(p)) { frag.appendChild(document.createTextNode(p)); return; }
            var sp = document.createElement('span'); sp.className = 'sw';
            var i = document.createElement('i'); i.textContent = p;
            sp.appendChild(i); frag.appendChild(sp);
          });
          n.parentNode.replaceChild(frag, n);
        } else if (n.nodeType === 1 && !n.hasAttribute('data-nosplit') &&
                   !n.classList.contains('sw') && n.tagName !== 'svg' && n.tagName !== 'BUTTON') {
          wrap(n);
        }
      });
    };
    $$('h1, section h2, section h3').forEach(function (h) {
      if (h.getAttribute('data-split')) return;
      h.setAttribute('data-split', '1');
      wrap(h);
      var words = h.querySelectorAll('.sw');
      var fire = function () {
        words.forEach(function (w, i) { w.classList.add('on'); w.firstChild.style.animationDelay = (i * 55) + 'ms'; });
      };
      if (h.getBoundingClientRect().top < innerHeight * 0.9 || typeof IntersectionObserver === 'undefined') { fire(); return; }
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { fire(); io.disconnect(); } });
      }, { threshold: 0.15 });
      io.observe(h);
    });
  }

  /* ── mission statement: words light up as the pinned section is scrubbed ── */
  var illum = null, illumN = -1;
  function prepIllum() {
    var p = $('[data-illum]'); if (!p) return;
    if (!claim(p, 'illum')) return;   /* already split into .mw spans */
    var out = [];
    Array.prototype.slice.call(p.childNodes).forEach(function (n) {
      if (n.nodeType === 3) {
        if (!n.textContent.trim()) return;
        var frag = document.createDocumentFragment();
        n.textContent.split(/(\s+)/).forEach(function (t) {
          if (!t) return;
          if (/^\s+$/.test(t)) { frag.appendChild(document.createTextNode(t)); return; }
          var sp = document.createElement('span'); sp.className = 'mw'; sp.textContent = t;
          frag.appendChild(sp); out.push(sp);
        });
        n.parentNode.replaceChild(frag, n);
      } else if (n.nodeType === 1) { n.classList.add('mw'); out.push(n); }
    });
    /* Keep a highlighted word and the punctuation after it on ONE line. Each
       .mn-w is a <button>, i.e. an inline-block — an ATOMIC inline, which gives
       the browser a break opportunity immediately after it even though there is
       no whitespace there. So "heard" could end a line and its comma drop to the
       next one alone; reproduced at a paragraph width of ~300px. Chrome refuses
       display:inline on a <button> (computed style stays inline-block), so bind
       the pair with a nowrap wrapper instead. The elements themselves are only
       re-parented, so `out` keeps working for the opacity reveal. */
    Array.prototype.slice.call(p.querySelectorAll('.mn-w')).forEach(function (btn) {
      var punct = btn.nextElementSibling;
      if (!punct || !/^[,.;:!?—]$/.test(punct.textContent.trim())) return;
      var keep = document.createElement('span');
      keep.style.whiteSpace = 'nowrap';
      btn.parentNode.insertBefore(keep, btn);
      keep.appendChild(btn);
      keep.appendChild(punct);
      /* One clause per line on phones. Left to itself the sentence wraps
         wherever it runs out of room, which splits a clause across two lines
         ("…deserves to be / heard, every writer…"). A break after each clause
         but the last gives the three lines the copy is written as. CSS decides
         whether it applies — .mn-br is display:none above the mobile tier, so
         the desktop paragraph still flows as before. */
      var br = document.createElement('br');
      br.className = 'mn-br';
      keep.parentNode.insertBefore(br, keep.nextSibling);
    });
    /* the final clause ends the sentence — no break after it */
    var brs = p.querySelectorAll('br.mn-br');
    if (brs.length) { brs[brs.length - 1].parentNode.removeChild(brs[brs.length - 1]); }
    illum = out; illumN = out.length;
    out.forEach(function (el) { el.style.opacity = '1'; });
  }
  function setIllum(n) {
    if (!illum || n === illumN) return;
    illum.forEach(function (el, i) { el.style.opacity = i < n ? '1' : '.2'; });
    illumN = n;
  }

  /* ── renderers ── */
  function renderSc() {
    $$('.sc-row').forEach(function (r) {
      var on = +r.getAttribute('data-i') === S.sc ? '1' : '0';
      r.setAttribute('data-on', on);
      var b = r.querySelector('.sc-b'); if (b) b.setAttribute('data-on', on);
    });
  }

  /* ── the letter deck ──
     V is the live card list. Everything about the deck is derived from its
     LENGTH rather than a hardcoded 6, so dropping more letters in (a Liquid
     loop on Shopify) needs no code change: the numbering, the wrap-around and
     the pile depth all follow the DOM. */
  var V = [];
  function pad2(n) { return (n < 10 ? '0' : '') + n; }

  function initVoices() {
    var deck = $('#vDeck'); if (!deck) return;
    V = $$('.vc', deck);
    if (!V.length) return;
    V.forEach(function (card, i) {
      card.setAttribute('data-vi', i);                 /* authored value is only a default */
      var n = card.querySelector('.vc-n');
      if (!n) {
        n = document.createElement('span');
        n.className = 'vc-n'; n.setAttribute('aria-hidden', 'true');
        card.appendChild(n);
      }
      n.textContent = pad2(i + 1) + ' / ' + pad2(V.length);
    });
    renderV();
  }

  /* data-pos is the card's DISTANCE from the front one: 0 is the letter being
     read, 1 and 2 are the two showing behind it in the desktop pile, and every
     other card parks at "x". Below 1080 only data-pos="0" is displayed. */
  function renderV() {
    var n = V.length; if (!n) return;
    S.v = ((S.v % n) + n) % n;                          /* wraps in both directions */
    V.forEach(function (card, i) {
      var d = (i - S.v + n) % n;
      card.setAttribute('data-pos', d < 3 ? String(d) : 'x');
    });
  }

  function renderCh() {
    $$('[data-ch]').forEach(function (b) { b.setAttribute('data-on', +b.getAttribute('data-ch') === S.ch ? '1' : '0'); });
    $$('[data-chp]').forEach(function (p) { p.setAttribute('data-show', +p.getAttribute('data-chp') === S.ch ? '1' : '0'); });
    trackCh();
  }

  /* Below 1080 the chapter rail is a horizontal scroller, so the button the
     scroll position just activated can sit off-screen. Keep it in view.
     Uses scrollLeft rather than scrollIntoView() — the latter would also
     scroll the PAGE vertically and fight the pinned section. */
  function trackCh() {
    var list = $('.ch-list'); if (!list) return;
    if (list.scrollWidth <= list.clientWidth + 4) return;      /* not scrollable */
    var btn = list.querySelector('[data-ch="' + S.ch + '"]'); if (!btn) return;
    var target = btn.offsetLeft - (list.clientWidth - btn.offsetWidth) / 2;
    target = Math.max(0, Math.min(target, list.scrollWidth - list.clientWidth));
    if (Math.abs(list.scrollLeft - target) < 4) return;
    if (list.scrollTo) list.scrollTo({ left: target, behavior: 'smooth' });
    else list.scrollLeft = target;
  }
  function renderMn() {
    $$('[data-mn]').forEach(function (b) { b.setAttribute('data-on', +b.getAttribute('data-mn') === S.mn ? '1' : '0'); });
    $$('[data-mnp]').forEach(function (p) { p.setAttribute('data-show', +p.getAttribute('data-mnp') === S.mn ? '1' : '0'); });
  }

  /* ── figures roll up when they change ── */

  /* ── clicking a chapter / step scrolls to that slice of the pinned run ── */
  function jump(sel, i, n) {
    var sec = $(sel); if (!sec) return false;
    var stage = $('.pin-stage', sec);
    if (!stage || getComputedStyle(stage).position !== 'sticky') return false;
    var top = sec.getBoundingClientRect().top + scrollY + ((i + 0.42) / n) * (sec.offsetHeight - innerHeight);
    scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
    return true;
  }


  /* How many slices each pinned section is divided into comes from the DOM, not
     from a baked-in number, so adding a chapter / belief / impact row (a block
     on Shopify) remaps the scroll on its own. n*0.99 reproduces the design's
     magic 2.97 at three panels and 3.96 at four rows exactly. */
  function slice(p, n) { return Math.max(0, Math.min(n - 1, Math.floor(p * n * 0.99))); }
  function chapterCount() { return $$('[data-chp]').length || 1; }
  function beliefCount()  { return $$('[data-mnp]').length || 1; }
  function impactCount()  { return $$('#impact .sc-row').length || 1; }

  /* ── one rAF loop drives every pinned section + the parallax ── */
  var mnHold = 0;
  function initScrollFX() {
    if (loopOn) return;             /* one loop, one set of listeners, per page */
    loopOn = true;
    var prog = function (el) {
      var r = el.getBoundingClientRect();
      return Math.min(1, Math.max(0, -r.top / Math.max(1, r.height - innerHeight)));
    };
    var isPinned = function (sec) {
      var st = sec && $('.pin-stage', sec);
      return !!st && getComputedStyle(st).position === 'sticky';
    };
    var apply = function () {
      var pars = $$('[data-par]');   /* read live — sections can load after init */
      var rail = $('#scrollRail');
      if (rail) {
        var max = document.documentElement.scrollHeight - innerHeight;
        rail.style.transform = 'scaleX(' + (max > 0 ? Math.min(1, scrollY / max) : 0) + ')';
      }
      var ch = $('#chapters');
      if (ch) {
        var nch = chapterCount();
        if (isPinned(ch)) {
          var p = prog(ch);
          var bar = $('#chRail'); if (bar) bar.style.width = (p * 100).toFixed(1) + '%';
          var idx = slice(p, nch);
          if (idx !== S.ch) { S.ch = idx; renderCh(); }
        } else {
          var bar2 = $('#chRail'); if (bar2) bar2.style.width = ((S.ch + 1) * (100 / nch)).toFixed(2) + '%';
        }
      }
      var imp = $('#impact');
      if (imp && isPinned(imp)) {
        var pi = prog(imp);
        var si = slice(pi, impactCount());
        if (si !== S.sc) { S.sc = si; renderSc(); }
      }
      var mn = $('#mission');
      if (mn && isPinned(mn)) {
        var pm = prog(mn);
        if (illum) setIllum(Math.min(illum.length, Math.round(pm * illum.length * 1.3)));
        var mi = slice(pm, beliefCount());
        if (mi !== S.mn && !(mnHold && Date.now() < mnHold)) { S.mn = mi; renderMn(); }
      } else if (illum) {
        setIllum(illum.length);          /* MOBILE: unpinned → fully lit */
      }
      pars.forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.bottom < -200 || r.top > innerHeight + 200) return;
        var c = (r.top + r.height / 2 - innerHeight / 2) / innerHeight;
        var amt = parseFloat(el.getAttribute('data-par')) || 0;
        el.style.setProperty('--py', (-c * amt * 100).toFixed(1) + 'px');
      });
    };
    var queued = false;
    var run = function () { queued = false; try { apply(); } catch (e) {} };
    var onScroll = function () { if (queued) return; queued = true; requestAnimationFrame(run); };
    addEventListener('scroll', onScroll, { passive: true });
    addEventListener('resize', onScroll, { passive: true });
    document.addEventListener('scroll', onScroll, { passive: true, capture: true });
    /* belt-and-braces: rAF alone is throttled while the tab is hidden */
    setInterval(run, 240);
    run();
  }

  /* ── reveals: only what starts below the fold is hidden ── */
  function initReveal() {
    var els = $$('[data-rv]');
    if (!els.length || typeof IntersectionObserver === 'undefined') return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target;
        el.style.animation = (el.getAttribute('data-rv') || 'rise') + ' .78s cubic-bezier(.22,.7,.25,1) ' +
                             parseInt(el.getAttribute('data-rv-d') || '0', 10) + 'ms both';
        io.unobserve(el);
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.06 });
    els.forEach(function (el) {
      if (!claim(el, 'rv')) return;
      if (el.getBoundingClientRect().top > innerHeight * 0.88) { el.style.opacity = '0'; io.observe(el); }
    });
  }

  /* ── the letter deck can be thrown with a pointer (works with touch) ── */
  var dragX0 = null;
  function initDeckDrag() {
    var deck = $('#vDeck'); if (!deck) return;
    if (!claim(deck, 'drag')) return;
    deck.addEventListener('pointerdown', function (e) { dragX0 = e.clientX; });
    if (deckDragOn) return;         /* the window-level release binds once */
    deckDragOn = true;
    addEventListener('pointerup', function (e) {
      if (dragX0 == null) return;
      var dx = e.clientX - dragX0; dragX0 = null;
      if (Math.abs(dx) < 44) return;
      S.v += (dx < 0 ? 1 : -1); renderV();          /* renderV() normalises S.v */
    });
  }

  /* ── MOBILE: the letters are position:absolute inside the deck, so the deck
     must be tall enough for the longest one. Measure with an inline
     !important (which beats the stylesheet's !important inset) and set it. ── */
  /* "By the numbers" — each figure rolls up once when it scrolls into view.
     The markup already renders the final value as text, so this is pure
     enhancement: if IntersectionObserver is missing, the numbers just sit there. */
  function initNums() {
    var els = $$('.num-cell b[data-num]');
    if (!els.length || typeof IntersectionObserver === 'undefined') return;
    function roll(el) {
      var target = parseInt(el.getAttribute('data-num'), 10);
      var pre = el.getAttribute('data-pre') || '', suf = el.getAttribute('data-suf') || '';
      var t0 = performance.now(), dur = 1100;
      function tick(t) {
        var k = Math.min(1, (t - t0) / dur), p = 1 - Math.pow(1 - k, 3);
        el.textContent = pre + Math.round(target * p).toLocaleString('en-US') + suf;
        if (k < 1) requestAnimationFrame(tick);
      }
      requestAnimationFrame(tick);
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (!en.isIntersecting) return; io.unobserve(en.target); roll(en.target); });
    }, { threshold: 0.4 });
    els.forEach(function (el) { if (claim(el, 'num')) io.observe(el); });
  }

  function sizeDeck() {
    var deck = $('#vDeck'); if (!deck) return;
    deck.style.minHeight = '';                      /* reset so the CSS floor is readable */
    var first = deck.querySelector('.vc');
    /* ≤1080 the cards are static one-up and size themselves — nothing to do */
    if (!first || getComputedStyle(first).position !== 'absolute') return;
    var h = 0;
    $$('.vc', deck).forEach(function (c) {
      /* inline !important is the only thing that beats the stylesheet's
         !important inset; scrollHeight would over-report because the byline's
         margin-top:auto stretches to fill the fixed box */
      c.style.setProperty('bottom', 'auto', 'important');
      c.style.setProperty('height', 'auto', 'important');
      h = Math.max(h, c.offsetHeight);
      c.style.removeProperty('height');
      c.style.setProperty('bottom', '0');
    });
    var floor = parseFloat(getComputedStyle(deck).minHeight) || 0;
    if (h + 30 > floor) deck.style.minHeight = Math.ceil(h + 30) + 'px';
  }

  /* ── wiring ── */
  function init() {
    splitWords(); prepIllum(); initReveal(); initScrollFX(); initVoices(); initDeckDrag(); initNums();

    $$('.sc-row').forEach(function (r) {
      if (!claim(r, 'row')) return;
      r.addEventListener('click', function () {
        var i = +r.getAttribute('data-i');
        if (!jump('#impact', i, impactCount())) { S.sc = i; renderSc(); }
      });
    });
    $$('[data-ch]').forEach(function (b) {
      if (!claim(b, 'ch')) return;
      b.addEventListener('click', function () {
        var i = +b.getAttribute('data-ch');
        if (!jump('#chapters', i, chapterCount())) { S.ch = i; renderCh(); }
      });
    });
    $$('[data-mn]').forEach(function (b) {
      if (!claim(b, 'mn')) return;
      var set = function () { mnHold = Date.now() + 3200; S.mn = +b.getAttribute('data-mn'); renderMn(); };
      b.addEventListener('mouseenter', set);
      b.addEventListener('focus', set);
      b.addEventListener('click', set);
    });
    $$('[data-v]').forEach(function (b) {
      if (!claim(b, 'v')) return;
      b.addEventListener('click', function () {
        S.v += (b.getAttribute('data-v') === 'next' ? 1 : -1); renderV();
      });
    });

    var deck = $('#vDeck');
    if (deck && claim(deck, 'hold')) {
      deck.addEventListener('mouseenter', function () { vHold = true; });
      deck.addEventListener('mouseleave', function () { vHold = false; });
    }

    /* hero subject word */
    var hw = $('#heroWord');
    if (hw && claim(hw, 'word')) {
      hw.addEventListener('mouseenter', function () { wHold = true; });
      hw.addEventListener('mouseleave', function () { wHold = false; });
    }

    /* The two tickers are page singletons and look their element up LIVE, so a
       section that loads later is picked up and one that is removed just stops. */
    if (!timersOn) {
      timersOn = true;
      setInterval(function () {
        var w = $('#heroWord');
        if (!w || wHold) return;
        var L = heroWords(w);
        S.w = (S.w + 1) % L.length;
        w.textContent = L[S.w];
        if (!reduce) { w.style.animation = 'none'; void w.offsetWidth; w.style.animation = 'flipWord .5s cubic-bezier(.22,.7,.25,1) both'; }
      }, 2600);
      /* letter deck autoplay */
      setInterval(function () { if (!vHold && V.length) { S.v += 1; renderV(); } }, 6200);
    }

    sizeDeck();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(sizeDeck);
    if (!sizeHooksOn) {
      sizeHooksOn = true;
      addEventListener('load', sizeDeck);
      var rt; addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(sizeDeck, 150); });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  /* Theme editor: adding/moving/editing a section re-renders it. init() is
     idempotent, so re-running it only wires whatever is newly in the DOM. */
  document.addEventListener('shopify:section:load', init);
})();
